import React, { useState, useEffect, createRef } from "react";
import Api from "../../../api/global.service.js";
import { useParams, useHistory } from "react-router-dom";
import CardContainer from "../../../components/card/card-container.jsx";
import BlockUi from "react-block-ui";

import "./ficha-master.css";

import ModalFichaCoopNuevoProyecto from "./modals/modal-ficha-coop-nuevo-proyecto.jsx";
import ModalFichaCoopClonaAnterior from "./modals/modal-ficha-coop-clona-anterior.jsx";

import FichaCoopItem from "./components/ficha-coop-item.jsx";

const FichaMasterDetalle = () => {
  const { id_kobo_ficha_principal } = useParams();
  const history = useHistory();
  const [blocking, setBlocking] = useState(false);
  const [data, setData] = useState([]);

  const dialog3 = createRef();
  const dialog4 = createRef();

  useEffect(() => {
    getFichas();
  }, []);

  const getFichas = async () => {
    setData([]);
    setTimeout(() => {
      setBlocking(true);
      Api.get("ficha/kobo/master/detalles", id_kobo_ficha_principal)
        .then((response) => {
          setData(response.data);
          setBlocking(false);
        })
        .catch(() => {
          setBlocking(false);
        });
    }, 250);
  };

  return (
    <>
      <div>
        <div className="row pb-4">
          <div className="col-xl-12">
            <button
              onClick={() => {
                dialog3.current.setData(data);
                dialog3.current.show();
              }}
              type="button"
              style={{ marginLeft: 10, marginTop: 20, marginRight: 20 }}
              className="float-xl-right btn btn-sirio"
            >
              <i className="fa fa-plus"></i>
              <span style={{ paddingLeft: 10 }}>{"Asociar nueva ficha"}</span>
            </button>
            {Number(data?.parent) > 0 && (
              <button
                onClick={() => {
                  dialog4.current.setData(data);
                  dialog4.current.show();
                }}
                type="button"
                style={{ marginLeft: 10, marginTop: 20, marginRight: 20 }}
                className="float-xl-right btn btn-success"
              >
                <i className="fa fa-copy"></i>
                <span style={{ paddingLeft: 10 }}>{"Copiar fichas ciclo anterior"}</span>
              </button>
            )}

            <button
              onClick={() => history.push(`/admin/ficha/master/lista`)}
              type="button"
              className="float-xl-right btn btn-outline-secondary"
              style={{
                marginTop: 20,
                borderRadius: "20px 20px 20px 20px",
              }}
            >
              <i className="fa fa-arrow-left"></i> Regresar
            </button>

            <CardContainer height="100%">
              <div className="row">
                <h2 className="col-xl-12">{data.nombre}</h2>
                <p style={{ paddingLeft: 20 }}>{data.descripcion}</p>
              </div>
              <hr />
              <div className="row">
                <h3 className="col-xl-12 font-lato-normal-400">
                  Fichas asociadas
                </h3>
              </div>
              <BlockUi
                tag="div"
                message=""
                blocking={blocking}
                renderChildren={true}
              >
                {!blocking && (!Array.isArray(data?.fichas) || data.fichas.length === 0) && (
                  <div className="alert alert-info">
                    No hay fichas asociadas para mostrar.
                  </div>
                )}
                {data?.fichas?.map((ficha) => (
                  <FichaCoopItem
                    data={ficha}
                    fichaMaster={data}
                    infoKobo={ficha.info_kobo || {}}
                    onModalClose={() => getFichas()}
                    key={ficha.id_kobo_ficha}
                  />
                ))}
              </BlockUi>
              <div>
                <ModalFichaCoopNuevoProyecto
                  ref={dialog3}
                  title="Nueva ficha de cooperativa"
                  onFinish={() => {
                    getFichas();
                  }}
                />
                <ModalFichaCoopClonaAnterior
                  ref={dialog4}
                  title="Copiar fichas de cooperativas del ciclo anterior"
                  onFinish={() => {
                    getFichas();
                  }}
                />
              </div>
            </CardContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default FichaMasterDetalle;
